import { Action, Thunk, action, thunk } from "easy-peasy";
import { get, post } from "requests";
import { Columns, COLUMNS } from "pages/applications/modules/columns";
import { ROLE_NAME, SCRUBBER, SUBMISSION } from "constants/Constants";

export interface ApplicationModel {
  columns: Columns[];
  applications: any[];
  loading: boolean;
  setApplications: Action<ApplicationModel, any[]>;
  setLoading: Action<ApplicationModel, boolean>;
  fetchApplications: Thunk<ApplicationModel>;
  fetchUsers: Thunk<ApplicationModel>;
  searchQuery: string;
  users: any[];
  filters: {
    Pending: boolean;
    Declined: boolean;
    Approved: boolean;
  };
  dateFilters: {
    fromDate: Date | null;
    toDate: Date | null;
  };
  range: string;
  setUsers: Action<ApplicationModel, any[]>;
  setFilters: Action<ApplicationModel, any>;
  setDateFilters: Action<ApplicationModel, any>;
  setRange: Action<ApplicationModel, string>;
  setSearchQuery: Action<ApplicationModel, string>;
}

const applicationModel: ApplicationModel = {
  applications: [],
  users: [],
  loading: false,
  columns: COLUMNS,
  filters: {
    Pending: true,
    Declined: true,
    Approved: true,
  },

  dateFilters: {
    fromDate: null,
    toDate: null,
  },

  range: "All Time",
  searchQuery: "",

  setSearchQuery: action((state, query) => {
    state.searchQuery = query;
  }),

  setApplications: action((state, applications) => {
    state.applications = applications;
  }),

  setLoading: action((state, loading) => {
    state.loading = loading;
  }),

  setUsers: action((state, users) => {
    state.users = users;
  }),

  setFilters: action((state, payload) => {
    state.filters = {
      ...state.filters,
      ...payload,
    };
  }),

  setDateFilters: action((state, payload) => {
    state.dateFilters = payload;
  }),

  setRange: action((state, payload) => {
    state.range = payload;
  }),

  fetchApplications: thunk(async (actions) => {
    actions.setLoading(true);
    try {
      const roleName = localStorage.getItem(ROLE_NAME);

      const payload: any = {};

      if (roleName === SCRUBBER || roleName === SUBMISSION) {
        payload.userId = localStorage.getItem("logInUserId");
      } else {
        payload.tenantId = localStorage.getItem("tenantId");
      }

      const response = await post("/fetchApplications", payload);
      actions.setApplications(response);
    } catch (error) {
      console.error("Error fetching applications:", error);
    } finally {
      actions.setLoading(false);
    }
  }),

  fetchUsers: thunk(async (actions) => {
    try {
      const users = await get("fetchAllInternalUsers");
      actions.setUsers(users);
    } catch (error) {
      console.error("Error fetching fetchAllInternalUsers:", error);
    }
  }),
};

export default applicationModel;
